module.exports = __webpack_public_path__ + "fonts/PretendardVariable.f67058f4.woff2";